import React, { ReactNode, useReducer } from "react";
import { initialState, reducer, SpinAction, SpinState } from "./spin.reducer";

export const SpinContext = React.createContext<{
  state: SpinState;
  dispatch: React.Dispatch<SpinAction>;
}>({
  state: initialState,
  dispatch: () => undefined,
});

export interface ProviderProps {
  children: ReactNode;
}

export const SpinProvider = (props: ProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <SpinContext.Provider value={{ state, dispatch }}>
      {props.children}
    </SpinContext.Provider>
  );
};
